import { useState } from "react";

/** A read-only value with a Copy button; selects the text where the clipboard is refused. */
export function CopyField({ id, label, value, secret = false }: { id: string; label: string; value: string; secret?: boolean }) {
  const [copied, setCopied] = useState(false);
  const [revealed, setRevealed] = useState(!secret);

  return (
    <div className="field">
      <label htmlFor={id}>{label}</label>
      <div className="row" style={{ gap: 8 }}>
        <input
          id={id}
          type={revealed ? "text" : "password"}
          readOnly
          value={value}
          className="mono grow"
          onFocus={(e) => e.currentTarget.select()}
        />
        {secret && (
          <button type="button" className="btn btn-sm" onClick={() => setRevealed((r) => !r)} aria-pressed={revealed}>
            {revealed ? "Hide" : "Show"}
          </button>
        )}
        <button
          type="button"
          className="btn btn-sm"
          onClick={async () => {
            try {
              await navigator.clipboard.writeText(value);
              setCopied(true);
              setTimeout(() => setCopied(false), 2000);
            } catch {
              (document.getElementById(id) as HTMLInputElement | null)?.select();
            }
          }}
        >
          {copied ? "Copied" : "Copy"}
        </button>
      </div>
    </div>
  );
}
